<template>
  <div class="py-5 mt-4">
    <div>
      <h2 class="titlePage font-weight-bold text-capitalize mb-1 h2">
        {{ $t('settings.twoWay.title') }}
      </h2>
    </div>
    <div style="min-height: 48px" class="mb-1">
      <transition name="fade" style="min-height: 30px">
        <MenssageAlert :messages="messages" />
      </transition>
    </div>
    <LoadingSpinner v-if="loadingConfig" size="sm" />

    <div v-else>
      <CCard>
        <CCardHeader class="font-weight-bolder">
          {{ $t('settings.twoWay.newConfiguration.header') }}
        </CCardHeader>
        <CCardBody>
          <CRow style="min-height: 290px">
            <!-- <CCol class="col-auto pt-1 mx-auto">
              <CIcon name="circle" class="text-primary pl-1" size="custom-size" :height="22" viewBox="0 0 32 32" />
              <div class="mx-auto stepper-separator"></div>
              <CIcon name="cilCircle" class="mt-1 pl-1 text-gray-300" size="custom-size" :height="24" viewBox="0 0 32 32" />
            </CCol> -->
            <CCol class="col-12">
              <CRow>
                <CCol md="6">
                  <label for="number" class="label-custom required mt-1">
                    {{ $t('settings.twoWay.newConfiguration.form.number.label') }}
                  </label>
                  <v-select
                    id="number"
                    v-model="$v.selectedNumber.$model"
                    class="mb-0 no-close mt-0 select-form"
                    label="accessNumber"
                    track-by="accessNumber"
                    :options="numberAvailableOptions"
                    :placeholder="
                      numberAvailableOptions.length > 0
                        ? $t('settings.twoWay.newConfiguration.form.number.placeholder')
                        : $t('settings.twoWay.newConfiguration.form.number.placeholderNoNumbers')
                    "
                    :disabled="isLoading || isActiveConfiguration"
                    @option:selecting="selectNumber"
                  >
                    <template v-slot:option="option">{{ option.accessNumber }}</template>
                    <template #selected-option="{ accessNumber }">
                      {{ accessNumber }}
                    </template>
                  </v-select>
                  <div style="display: inline-block" class="invalid-feedback" v-if="$v.selectedNumber.$error">
                    {{ $t('settings.twoWay.newConfiguration.form.period.required') }}
                  </div>
                </CCol>
              </CRow>
              <div class="mt-4">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('settings.twoWay.newConfiguration.form.period.label') }}
                </label>
              </div>

              <div>
                <CInputRadio
                  name="periodType"
                  inline
                  :checked="this.periodType == 'onlyInitial'"
                  class="mr-4"
                  :label="$t('settings.twoWay.newConfiguration.form.period.only-begin-date')"
                  :disabled="isLoading || isEditing"
                  @update:checked="selectPeriodType('onlyInitial')"
                />
                <CInputRadio
                  name="periodType"
                  inline
                  :checked="this.periodType == 'period'"
                  :label="$t('settings.twoWay.newConfiguration.form.period.begin-and-end-date')"
                  :disabled="isLoading || isEditing"
                  @update:checked="selectPeriodType('period')"
                />
              </div>
              <div class="w-50 mt-3">
                <CRow style="height: 100px">
                  <CCol>
                    <v-date-picker
                      v-model="$v.initialDate.$model"
                      color="purple"
                      is-inline
                      addInputClasses="p-5 date-picker__input"
                      mode="dateTime"
                      is24hr
                      :minDate="new Date()"
                      :valid-hours="{
                        min: initialDate && initialDate.toDateString() === new Date().toDateString() ? new Date().getHours() : 0,
                      }"
                      @change="changeIniDate"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <CInput
                          :class="canEditInitDate && !isEditing ? 'dateInputCustom' : ''"
                          readonly
                          :value="inputValue"
                          v-on="!isLoading && !isEditing && canEditInitDate ? inputEvents : null"
                          :isValid="!$v.initialDate.$error"
                          :invalidFeedback="$t('settings.twoWay.newConfiguration.form.period.required')"
                          :disabled="!canEditInitDate && (isLoading || isEditing)"
                          :title="canEditInitDate ? '' : $t('settings.twoWay.newConfiguration.form.period.beginDateUnavailable')"
                        >
                          <template #append-content>
                            <CIcon name="calendar" size="custom-size" :height="20" viewBox="0 0 32 32" />
                          </template>
                        </CInput>
                      </template>
                    </v-date-picker>
                    <!-- <span v-if="!isEditing" class="text-error" style="font-size: 12px">
                      {{ canEditInitDate ? '' : $t('settings.twoWay.newConfiguration.form.period.beginDateUnavailable') }}
                    </span> -->
                  </CCol>
                  <CCol>
                    <v-date-picker
                      v-if="isPeriod"
                      color="purple"
                      v-model="$v.endDate.$model"
                      is-inline
                      addInputClasses="p-5 date-picker__input"
                      mode="dateTime"
                      is24hr
                      :minDate="initialDate || new Date()"
                      :valid-hours="{
                        min: initialDate && endDate && initialDate.toDateString() === endDate.toDateString() ? initialDate.getHours() + 1 : 0,
                      }"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <CInput
                          :class="canEditEndDate && !isEditing ? 'dateInputCustom' : ''"
                          readonly
                          :value="inputValue"
                          v-on="!isLoading && initialDate && !isEditing && canEditEndDate ? inputEvents : null"
                          :isValid="!$v.endDate.$error"
                          :invalidFeedback="$t('settings.twoWay.newConfiguration.form.period.required')"
                          :disabled="isLoading || isEditing"
                          :title="canEditEndDate ? '' : $t('settings.twoWay.newConfiguration.form.period.endDateUnavailable')"
                        >
                          <template #append-content>
                            <CIcon name="calendar" size="custom-size" :height="20" viewBox="0 0 32 32" />
                          </template>
                        </CInput>
                      </template>
                    </v-date-picker>
                    <!-- <span v-if="!isEditing" class="text-error" style="font-size: 12px">
                      {{ canEditEndDate ? '' : $t('settings.twoWay.newConfiguration.form.period.endDateUnavailable') }}
                    </span> -->
                  </CCol>
                </CRow>
              </div>
            </CCol>
          </CRow>

          <div v-if="(isActiveConfiguration && editing) || !isActiveConfiguration" class="mt-3 py-3 text-right">
            <CButton color="white" class="px-5 py-2 border" :disabled="loadingConfig || loadingSave" @click="showCancelModal = true">
              {{ $t('settings.twoWay.newConfiguration.form.button.cancel') }}
            </CButton>
            <CButton color="primary" class="px-5 py-2 ml-3" :disabled="loadingConfig || $v.$invalid || loadingSave" @click="saveConfiguration()">
              {{ $t('settings.twoWay.newConfiguration.form.button.saveAndContinue') }}
            </CButton>
          </div>
          <div v-else class="mt-3 py-3 text-right">
            <CButton
              v-if="isActiveConfiguration && !editing && isSenditUser && (canEditInitDate || canEditEndDate)"
              color="primary"
              class="px-5 mt-3 ml-4"
              variant="outline"
              @click="editing = true"
            >
              <CIcon name="cilPencil" size="custom-size" :height="14" viewBox="0 0 32 32" />
              {{ $t('settings.twoWay.newConfiguration.form.button.edit') }}
            </CButton>
            <!-- <CButton color="primary" class="px-5 py-2 ml-3" :disabled="loadingConfig" @click="$router.push({ name: 'twoway-configuration' })">
              {{ $t('settings.twoWay.newConfiguration.form.button.close') }}
            </CButton> -->
          </div>
        </CCardBody>
      </CCard>

      <CCard v-if="isActiveConfiguration">
        <CCardHeader class="font-weight-bolder">
          <CRow>
            <CCol>
              {{ $t('settings.twoWay.newConfiguration.keywords.header') }}
            </CCol>
            <CCol>
              <div v-if="!isEnded" class="text-right">
                <CButton color="primary" class="ml-3 px-4 py-1" @click="showNewKeywordModal = true">
                  <CIcon name="cilPlus" class="mr-1" :height="23" viewBox="0 0 32 32" />
                  {{ $t('settings.twoWay.newConfiguration.form.addKeyword.button') }}
                </CButton>
              </div>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <KeywordList :keywords-list="keywords" :isEnded="isEnded" @edit-keyword="openEditKeywordModal" @delete-keyword="openDeleteKeywordModal" />
        </CCardBody>
      </CCard>

      <FallbackConfig
        v-if="isActiveConfiguration"
        :organizationAccessNumberId="organizationAccessNumberId"
        :keywords-list="keywords"
        :isEnded="isEnded"
        @edit-fallback="openEditFallbackModal"
        @remove-fallback="removeFallback"
        @creation-success="keywordCreationSuccess"
        @creation-error="keywordCreationError"
      />
    </div>

    <CModal :show.sync="showCancelModal" :closeOnBackdrop="false">
      <template #header-wrapper>
        <div class="py-3"></div>
        <!-- <h5 class="pt-5 pb-2">{{ $t('settings.twoWay.newConfiguration.cancelModal.header') }}</h5> -->
      </template>
      <template #body-wrapper>
        <div class="">{{ $t('settings.twoWay.newConfiguration.cancelModal.title') }}</div>
      </template>
      <template #footer-wrapper>
        <div class="mt-5 text-right">
          <CButton color="white" class="px-4 mr-2" @click="cancelConfiguration()">{{
            $t('settings.twoWay.newConfiguration.cancelModal.button.back')
          }}</CButton>
          <CButton color="primary" class="px-4" @click="confirmCancelConfiguration()">
            {{ $t('settings.twoWay.newConfiguration.cancelModal.button.confirm') }}
          </CButton>
        </div>
      </template>
    </CModal>

    <CModal :show.sync="showNewKeywordModal" :closeOnBackdrop="false">
      <template #header-wrapper>
        <h5 class="py-2 px-2">
          {{
            keywordIdEdit
              ? $t('settings.twoWay.newConfiguration.edit-keyword.modal.title')
              : $t('settings.twoWay.newConfiguration.add-keyword.modal.title')
          }}
        </h5>
      </template>
      <template #body-wrapper>
        <KeywordForm
          v-if="showNewKeywordModal"
          ref="keyWordModal"
          :organizationAccessNumberId="organizationAccessNumberId"
          :keywordId="keywordIdEdit"
          @creation-success="keywordCreationSuccess"
          @creation-error="keywordCreationError"
          @close-modal="closeKeywordModal"
        />
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>

    <CModal :show.sync="showEditFallbackModal" :closeOnBackdrop="false">
      <template #header-wrapper>
        <h5 class="py-2 px-2">
          {{ $t('settings.twoWay.newConfiguration.fallback.modal.title') }}
        </h5>
      </template>
      <template #body-wrapper>
        <KeywordForm
          v-if="showEditFallbackModal"
          ref="fallbackModal"
          :organizationAccessNumberId="organizationAccessNumberId"
          :keywordId="fallbackId"
          isFallback
          @creation-success="keywordCreationSuccess"
          @creation-error="keywordCreationError"
          @close-modal="closeEditFallbackModal"
        />
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>

    <CModal :show.sync="showDeleteKeywordModal" :closeOnBackdrop="false">
      <template #header-wrapper>
        <h5 class="pb-5">{{ $t('settings.twoWay.newConfiguration.keyword-delete.header') }}</h5>
      </template>
      <template #body-wrapper>
        <div class="">{{ $t('settings.twoWay.newConfiguration.keyword-delete.title') }}</div>
      </template>
      <template #footer-wrapper>
        <div class="mt-5 text-right">
          <CButton color="white" class="px-4 mr-2" :disabled="loadingDelete" @click="closeDeleteKeywordModal">
            {{ $t('settings.twoWay.newConfiguration.keyword-delete.button.cancel') }}
          </CButton>
          <CButton color="primary" class="px-4" :disabled="loadingDelete" @click="deleteKeyword">
            {{ $t('settings.twoWay.newConfiguration.keyword-delete.button.confirm') }}
          </CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>
<script>
import LoadingSpinner from '@/components/LoadingSpinner'
import MenssageAlert from '@/components/MenssageAlert'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import vSelect from 'vue-select'
import services from '@/services.js'
import KeywordList from '../components/KeywordList.vue'
import KeywordForm from '../components/keywordForm.vue'
import FallbackConfig from '../components/FallbackConfiguration.vue'
import { DateTime } from 'luxon'

const formatTimezoneWithoutOffset = (date) => {
  if (date instanceof Date) {
    const offset = date.getTimezoneOffset() * 60000
    return new Date(date.valueOf() - offset).toISOString().slice(0, -1)
  } else {
    return null
  }
}

export default {
  name: 'NewTwoWayConfiguration',
  mixins: [validationMixin],
  components: {
    LoadingSpinner,
    MenssageAlert,
    vSelect,
    KeywordList,
    KeywordForm,
    FallbackConfig,
  },
  data() {
    return {
      messages: [],
      selectedNumberOption: null,
      selectedNumber: null,
      numberAvailableOptions: [],
      selectedNumberAvailable: null,
      periodType: 'onlyInitial',
      initialDate: null,
      endDate: null,
      showCancelModal: false,
      loadingConfig: false,
      editing: false,
      loadingSave: false,
      keywords: [],
      showNewKeywordModal: false,
      showDeleteKeywordModal: false,
      showEditFallbackModal: false,
      organizationAccessNumberId: null,
      keywordIdEdit: null,
      keywordIdDelete: null,
      fallbackId: null,
      loadingDelete: false,
      currentDate: DateTime.fromJSDate(new Date()),
    }
  },
  computed: {
    isEditing() {
      return this.isActiveConfiguration && !this.editing
    },
    isSenditUser() {
      return this.$store.getters['auth/isSendit']
    },
    isPeriod() {
      return this.periodType == 'period'
    },
    isActiveConfiguration() {
      return this.$route.params.configurationId ? true : false
    },
    isLoading() {
      return this.loadingSave
    },
    // Verifica se a data atual é maior que a data fim
    isEnded() {
      if (!this.endDate) return false
      return DateTime.fromJSDate(this.endDate) <= DateTime.fromJSDate(new Date())
    },

    canEditInitDate() {
      if (this.$route.name === 'new-two-way-configuration') return true
      return this.initialDate ? this.currentDate < DateTime.fromJSDate(this.initialDate) : true
    },

    canEditEndDate() {
      if (this.$route.name === 'new-two-way-configuration') return true
      return this.endDate ? this.currentDate < DateTime.fromJSDate(this.endDate) : true
    },

    hasFallbackConfigured() {
      return this.keywords ? this.keywords.some((el) => el.isDefault) : false
    },
  },
  validations() {
    return {
      selectedNumber: {
        required,
      },
      initialDate: {
        required,
      },
      endDate: {
        required: requiredIf(() => this.periodType == 'period'),
      },
    }
  },
  mounted() {
    this.getNumbers()
  },
  methods: {
    openEditFallbackModal(id) {
      this.showEditFallbackModal = true
      this.fallbackId = id
    },
    closeEditFallbackModal() {
      this.$refs.fallbackModal?.clearData()
      this.showEditFallbackModal = false
      this.fallbackId = null
    },
    changeIniDate() {
      this.endDate = null
    },
    closeKeywordModal() {
      this.$refs.keyWordModal?.clearData()
      this.showEditKeywordModal = this.showNewKeywordModal = false
      this.keywordIdEdit = null
    },
    keywordCreationSuccess(message) {
      this.messages = []
      this.messages.push(message)
      this.closeKeywordModal()
      this.closeEditFallbackModal()
      this.getConfiguration()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    keywordCreationError(message) {
      this.messages = []
      this.messages.push(message)
      this.closeEditFallbackModal()
      this.closeKeywordModal()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    openEditKeywordModal(id) {
      this.keywordIdEdit = id
      this.showNewKeywordModal = true
    },

    openDeleteKeywordModal(id) {
      this.keywordIdDelete = id
      this.showDeleteKeywordModal = true
    },

    removeFallback(id) {
      this.keywordIdDelete = id

      this.deleteKeyword(null, this.$t('settings.twoWay.newConfiguration.fallback.delete.success'))
    },

    deleteKeyword(e, successMsg = null) {
      this.loadingDelete = true
      this.messages = []

      const organizationId = this.$route.params.organizationId

      services
        .deleteTwoWayKeyword(organizationId, this.organizationAccessNumberId, this.keywordIdDelete)
        .then(() => {
          this.getConfiguration()
          this.messages.push({
            status: 'success',
            text: successMsg ? successMsg : this.$t('settings.twoWay.newConfiguration.keyword-delete.message.success'),
          })
          this.showDeleteKeywordModal = false
        })
        .catch(({ response }) => {
          const message = {
            status: 'danger',
            text: response.data.message,
          }
          this.$emit('creation-error', message)
        })
        .finally(() => {
          this.loadingDelete = false
          window.scrollTo({ top: 0, behavior: 'smooth' })
        })
    },

    closeDeleteKeywordModal() {
      this.keywordIdDelete = null
      this.showDeleteKeywordModal = false
    },

    changeInitialDate() {
      this.endDate = null
    },
    cancelConfiguration() {
      this.showCancelModal = false
    },
    confirmCancelConfiguration() {
      if (this.isActiveConfiguration && this.editing) {
        this.editing = false
        this.showCancelModal = false
        this.getConfiguration()
      } else {
        this.$router.push({ name: 'twoway-configuration' })
      }
    },
    getConfiguration() {
      const organizationId = this.$route.params.organizationId

      if (this.organizationAccessNumberId) {
        this.loadingConfig = true
        services
          .getTwoWayAccessNumberConfiguration(organizationId, this.organizationAccessNumberId)
          .then((res) => {
            let numberOption = this.numberAvailableOptions.find((el) => el.accessNumberId == res.data.data.accessNumberId)

            if (!numberOption) {
              numberOption = { accessNumber: res.data.data.number, accessNumberId: res.data.data.accessNumberId }
              this.numberAvailableOptions.unshift(numberOption)
            }

            this.selectedNumber = numberOption
            this.periodType = res.data.data.endDatetime ? 'period' : 'onlyInitial'
            this.initialDate = new Date(res.data.data.beginDatetime)
            this.endDate = res.data.data.endDatetime ? new Date(res.data.data.endDatetime) : ''
            this.keywords = res.data.data.keywords
          })
          .finally(() => (this.loadingConfig = false))
      }
    },
    getNumbers() {
      this.organizationAccessNumberId = this.$route.params.configurationId
      const organizationId = this.$route.params.organizationId
      this.loadingConfig = true

      services
        .getTwoWayAvaibleNumbers(organizationId)
        .then((res) => {
          this.numberAvailableOptions = res.data.data
          if (this.organizationAccessNumberId) {
            this.getConfiguration()
          } else {
            this.loadingConfig = false
          }
        })
        .catch(() => (this.loadingConfig = false))
    },
    selectNumber(value) {
      this.selectedNumberAvailable = value
    },
    selectPeriodType(value) {
      this.periodType = value
      this.endDate = null
      this.$v.endDate.$reset()
    },
    saveConfiguration() {
      this.$v.$touch()

      if (this.$v.$invalid) return

      if (this.$route.name === 'edit-two-way-configuration') {
        this.editConfiguration()
        return
      }

      this.loadingSave = true

      const organizationId = this.$route.params.organizationId

      const body = {
        accessNumberId: this.selectedNumber.accessNumberId,
        organizationId: organizationId,
        beginDateTime: formatTimezoneWithoutOffset(this.initialDate),
        endDateTime: this.endDate ? formatTimezoneWithoutOffset(this.endDate) : null,
        timezone: 'Europe/Lisbon',
      }

      this.messages = []

      services
        .createTwoWayConfiguration(organizationId, body)
        .then((res) => {
          this.messages.push({
            status: 'success',
            text: this.$t('settings.twoWay.newConfiguration.success'),
          })

          setTimeout(() => {
            this.$router.push({ name: 'edit-two-way-configuration', params: { configurationId: res.data.data.id } })
          }, 2000)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
          this.loadingSave = false
        })
    },

    editConfiguration() {
      const organizationId = this.$route.params.organizationId
      const organizationAccessNumberId = this.$route.params.configurationId

      const body = {
        beginDateTime: formatTimezoneWithoutOffset(this.initialDate),
        endDateTime: this.endDate ? formatTimezoneWithoutOffset(this.endDate) : null,
        timezone: 'Europe/Lisbon',
      }

      this.loadingSave = true

      this.messages = []

      services
        .updateTwoWayConfiguration(organizationId, organizationAccessNumberId, body)
        .then(() => {
          this.messages.push({
            status: 'success',
            text: this.$t('settings.twoWay.newConfiguration.edit.success'),
          })

          this.getConfiguration()
          this.confirmCancelConfiguration()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
          this.loadingSave = false
        })
        .finally(() => (this.loadingSave = false))
    },
  },
}
</script>
<style>
.dateInputCustom .form-control[readonly] {
  background-color: white !important;
}

.stepper-separator {
  padding-right: 4px;
  height: 250px;
  width: 0px;
  border-left: 1px solid black;
}
</style>
